"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var state_1 = require("../default/state");

var ParallaxBackgroundHtmlRenderer = function ParallaxBackgroundHtmlRenderer(props) {
  var children = props.children,
      _a = props.state,
      _b = _a.darken,
      darken = _b === void 0 ? state_1.defaultState.darken : _b,
      _c = _a.background,
      background = _c === void 0 ? state_1.defaultState.background : _c;
  return React.createElement("div", {
    className: "ory-plugins-layout-parallax-background",
    style: {
      backgroundImage: "linear-gradient(rgba(0, 0, 0, " + darken + "), rgba(0, 0, 0, " + darken + ")), url('" + background + "')"
    }
  }, children);
};

exports.default = ParallaxBackgroundHtmlRenderer;